import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';

import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { FlexRow } from 'ui-components/components/flex';
import { messages } from './messages';
import style from './call-to-action.module.less';

export const NewLineUpBYOACallToAction = ({ onAddCarrier, isFeatureEnabled }) => {
  return (
    <FlexRow className={style['add-carrier-button-row']}>
      <Button className={style['add-carrier-button']} disabled={!isFeatureEnabled} onClick={onAddCarrier} theme={THEME_CONSTANTS.primary}>
        {!isFeatureEnabled && <FontAwesomeIcon className={style['feature-gate-icon']} icon={faLock} />}
        <FormattedMessage {...messages.addCarrier} />
      </Button>
    </FlexRow>
  );
};
